import React from 'react';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';

import { Confirmation } from './confirmation';
import { DriverTipWithLabel } from '../../../../../fulfillment-planner/local-delivery/driver-tip/with-label';
import { RestrictedShipmentSection } from '../../../../../fulfillment-planner/restricted-shipment-config';
import { FulfillmentPlannerError } from '../../../../../fulfillment-planner/error';
import { Package } from './package';
import { PickupWithLabel } from '../../../../../fulfillment-planner/local-delivery/pickup/with-label';
import { RateAndCreateLabel } from '../../../../../fulfillment-planner/rate-and-create-label';
import { RequestedService } from './requested-service';
import { ShipFrom } from './ship-from';
import { CSWShippingDefaultsButton } from '../../../../../fulfillment-planner/shipping-default-button/index';
import { ShippingService } from './shipping-service';
import { Weight } from '../../../../../fulfillment-planner/weight/weight';

import { ComponentStates } from '../../../../../enums/component-states';
import { useFulfillmentPlannerContext } from '../../../../../fulfillment-planner/context';
import style from './style.module.less';

const sizeAndWeightClassNames = {
  'size-input': style['size-input'],
  'weight-input': style['weight-input'],
  container: style['size-and-weight-container'],
  label: style.label,
  scale: style.scale,
  weight: style.weight,
};

export const DrawerLocalDeliveryConfiguration = ({ fulfillmentPlanId }) => {
  const { uiRestrictions } = useFulfillmentPlannerContext();
  const hideConfigureShipment = uiRestrictions?.labelConfiguration?.componentState === ComponentStates.Hidden;
  return (
    <div {...testId('csw')}>
      {hideConfigureShipment ? (
        <RestrictedShipmentSection fulfillmentPlanId={fulfillmentPlanId} />
      ) : (
        <>
          <div className={style['drawer-fulfillment-configuration']}>
            <RequestedService fulfillmentPlanId={fulfillmentPlanId} />
            <ShipFrom fulfillmentPlanId={fulfillmentPlanId} />
            <Weight classNames={sizeAndWeightClassNames} showScale />
            <ShippingService fulfillmentPlanId={fulfillmentPlanId} />
            <PickupWithLabel fulfillmentPlanId={fulfillmentPlanId} />
            <Package fulfillmentPlanId={fulfillmentPlanId} />
            <Confirmation fulfillmentPlanId={fulfillmentPlanId} />
            <DriverTipWithLabel fulfillmentPlanId={fulfillmentPlanId} />
            <FulfillmentPlannerError className={style['error-container']} />
          </div>
          <CSWShippingDefaultsButton fulfillmentPlanId={fulfillmentPlanId} />
        </>
      )}
      <RateAndCreateLabel fulfillmentPlanId={fulfillmentPlanId} isQuickshipCompatible />
    </div>
  );
};

DrawerLocalDeliveryConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
